import styled from 'styled-components';

export const StyledCardConnectionContainer = styled.div`
    cursor: pointer;
    align-items: center;
    justify-content: center;
    gap: 24px;
    display: flex;
    width: 354px;
    height: 228px;
    flex-direction: column;
    border-radius: var(--2, 16px);
    background: #ffffff;
    /* elevation/4 */
    box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.12),
        0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 2px 4px -1px rgba(0, 0, 0, 0.2);
`;

export const StyledInlineCardContainer = styled.div`
    display: flex;
    justify-content: center;
    justify-items: center;
    border-radius: 3px;
    background: #ffffff;
    cursor: pointer;
    flex-direction: column;
    align-items: center;
`;

export const StyledCardSwitchContainer = styled.div`
    display: flex;
    padding: 20px;
    align-items: center;
    border-radius: 3px;
    background: #ffffff;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.15);
    margin-bottom: 12px;
    justify-content: space-between;
`;

export const StyledContentContainer = styled.div`
    display: flex;
    gap: 20px;
`;

export const StyledSwitchLabelContainer = styled.div`
    display: flex;
    gap: 12px;
`;

export const StyledWaizenLogoStyle = styled.img`
    width: 94px;
    height: 18;
    margin: 13.08px 18.46px 12.31px;
`;

export const StyledCardServiceContainer = styled.div<{
    canBeSetUp: boolean;
    isOrganizationDataLoading: boolean;
}>`
    display: flex;
    padding: 24px;
    align-items: center;
    border-radius: 1px;
    background: #ffffff;
    border: 1px solid #d6d6d6;
    justify-content: space-between;
    height: 20px;
    width: 400px;
    opacity: ${(props) =>
        props.canBeSetUp && !props.isOrganizationDataLoading ? '1' : '0.5'};
    &:hover {
        cursor: ${(props) =>
            props.canBeSetUp && !props.isOrganizationDataLoading
                ? 'pointer'
                : 'not-allowed'};
    }
`;

export const StyledToggleColumnAlignedContainer = styled.div`
    display: flex;
    padding: 24px;
    align-items: left;
    border-radius: 1px;
    background: #ffffff;
    border: 1px solid #d6d6d6;
    justify-content: space-between;
    width: 415px;
    flex-direction: column;
`;

export const StyledToggleCardContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 415px;
`;

export const StyledStep3DivButtons = styled.div`
    display: flex;
    justify-content: space-between;
`;
